// extracted by mini-css-extract-plugin
module.exports = {"inlineSvg":"SVGInline_inlineSvg__1AIx3","hidden":"SVGInline_hidden__388jT"};